import { useState } from 'react';
import { useQuery } from 'react-query';
import { useFilterToolbarState } from 'hooks/filterToolbar/useFilterToolbarState';
import { useScoutbotSavedSearchQueries } from 'hooks/projectMap/useScoutbotSavedSearchQueries';
import { fetchAddressList } from 'pages/ProjectInsights/services';
import { useSelectedMapMarkerAddress, useSelectedClusterId } from 'state/map';
import { useAddressQuery } from 'state/queryParams';

export const useProjectsOnAPin = () => {
  const [page, setPage] = useState(1);
  const { filterFieldsState, getFiltersAsQueryParams, getMapStateAsQueryParams } =
    useFilterToolbarState();
  const [address] = useAddressQuery();
  const [selectedClusterId] = useSelectedClusterId();
  const [selectedMapMarkerAddress] = useSelectedMapMarkerAddress();
  const { isScoutSearch, rawQueries } = useScoutbotSavedSearchQueries();

  const projectsList = useQuery(
    [
      'map-search-project-list',
      filterFieldsState,
      address,
      selectedClusterId,
      selectedMapMarkerAddress,
      page,
      isScoutSearch,
      rawQueries,
    ],
    () => {
      const locationParam: { cluster_id?: string; address?: string } = {};
      if (selectedClusterId) {
        locationParam.cluster_id = selectedClusterId;
      } else if (selectedMapMarkerAddress) {
        locationParam.address = selectedMapMarkerAddress;
      } else {
        locationParam.address = address;
      }
      const allFilters = getFiltersAsQueryParams();
      const mapState = getMapStateAsQueryParams();
      // A scoutbot search's real filters live in raw_queries - the
      // individual filter fields stay empty, so only the date/status fields
      // (which the raw-queries path also applies) still apply on top of it.
      const filterState = isScoutSearch
        ? {
            raw_queries: rawQueries,
            startDate: allFilters.startDate,
            createdAtStart: allFilters.createdAtStart,
            createdAtEnd: allFilters.createdAtEnd,
            status: allFilters.status,
          }
        : allFilters;

      return fetchAddressList({
        ...filterState,
        ...mapState,
        ...locationParam,
        page,
      });
    },
    {
      getNextPageParam: (lastPage) => lastPage?.nextPage,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    },
  );

  return {
    projectsList,
    setPage,
  };
};
